module.exports = __webpack_public_path__ + "static/media/3. In App Home.3940ba79.svg";